import { render, staticRenderFns } from "./DemoFormViews.vue?vue&type=template&id=7c714f81&scoped=true"
import script from "./DemoFormViews.vue?vue&type=script&lang=js"
export * from "./DemoFormViews.vue?vue&type=script&lang=js"
import style0 from "./DemoFormViews.vue?vue&type=style&index=0&id=7c714f81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c714f81",
  null
  
)

export default component.exports